import {createReducer} from '@reduxjs/toolkit';
import {cleanChangeRequestReview} from 'src/modules/ai/change-request-review/services/actions';
import {getChangeRequestReviewByIdSuccess} from 'src/openapi/apis/ChangeRequestReviewControllerApi';
import {ChangeRequestReview} from 'src/openapi/models/ChangeRequestReview';

type State = {
    data: Record<string, ChangeRequestReview>,
};

const defaultState = {
    data: {},
};

export const changeRequestReview = createReducer<State>(defaultState, builder => builder
    .addCase(getChangeRequestReviewByIdSuccess, (state, action) => {
        state.data = {...state.data, [action.payload.meta.changeRequestId]: action.payload.data};
    }).addCase(cleanChangeRequestReview, state => {
        state.data = {};
    }),
);
